// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1990) return "static/chunks/1990-959bd036b898325d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3265":"cd6cebc35bdfce71","4368":"fda1c907d5b9875c"}[chunkId] + ".js";
};